





































import Vue from 'vue';
import Modal from './Modal.vue';
import Button from '../Button/Button.vue';
import { axiosApiInstance } from '@/utils/axiosInstances';

export default Vue.extend({
  components: {
    Modal,
    Button,
  },
  data(): {
    showSecret: boolean;
    secretKey: string;
  } {
    return {
      showSecret: false,
      secretKey: process.env.VUE_APP_AGENT_SECRET_KEY,
    };
  },
  methods: {
    onClickDownloadAgent() {
      this.$store.commit('startLoading');

      this.showSecret = true;
      axiosApiInstance
        .get('/api/v1/files/agentInstaller', {
          responseType: 'blob',
        })
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'aiqaAgentInstaller.exe');
          document.body.appendChild(link);
          link.click();
        })
        .catch((error) => {
          console.error(error);
          alert('다운로드에 실패했습니다. 잠시 후 다시 시도해주세요.');
        })
        .finally(() => {
          this.$store.commit('stopLoading');
        });
    },
    onClickRunAgent() {
      window.open('aiqa://', '_blank');
      this.$store.commit('setAgentAliveStatus', true);
    },
  },
});
